import { API_CONFIG, apiCall, getHeadersWithOrg } from './client';
import { PLATFORM_ENDPOINTS } from '../../config/config';
import { DomainFilterSettings, DomainFilterConfig } from '../../types';

/**
 * Fetch the domain-level DITAVAL filter settings for a site.
 * Returns `{ filter_settings: null, updated_at: null }` when none are saved.
 */
export async function getDomainFilterSettings(siteId: string): Promise<DomainFilterSettings> {
  return apiCall<DomainFilterSettings>(
    `${API_CONFIG.PLATFORM_BASE_URL}${PLATFORM_ENDPOINTS.DOMAIN_FILTER_SETTINGS(siteId)}`,
    {
      method: 'GET',
      headers: getHeadersWithOrg(),
    },
  );
}

/**
 * Replace the domain-level DITAVAL filter settings for a site.
 * Pass `null` to clear all filters. Requires the `site:update:site` permission.
 */
export async function updateDomainFilterSettings(
  siteId: string,
  filterSettings: DomainFilterConfig | null,
): Promise<DomainFilterSettings> {
  return apiCall<DomainFilterSettings>(
    `${API_CONFIG.PLATFORM_BASE_URL}${PLATFORM_ENDPOINTS.DOMAIN_FILTER_SETTINGS(siteId)}`,
    {
      method: 'PUT',
      headers: getHeadersWithOrg(),
      body: JSON.stringify({ filter_settings: filterSettings }),
    },
  );
}
